export const CLICK = 'click';
export const FOCUS = 'focus';
export const TITLE = 'title';
export const EMPTY_STRING = '';
export const CHECKED = 'checked';
export const MOUSEOUT = 'mouseout';
export const DISABLED = 'disabled';
export const SCROLL_BAR_EXTRA = 20;
export const ACTIVE = 'xpop-active';
export const MOUSEOVER = 'mouseover';
export const CLEAR_INPUT_DELAY = 2000;
export const TEMP_ELEMENT_ID = 'xoomtemp';
export const CUSTOM_RADIO_CONTAINER = 'custom-radio-container';

export const popupCache = {};
export const popupTypes = {
  tooltip: {
    className: 'xtip',
  },
  error: {
    className: 'xtip-error',
  },
  'help-popup-ajax': {
    className: 'help-popup',
  },
};
export const defaultOptions = {
  type: 'tooltip',
  className: EMPTY_STRING,
  persist: 0,
  align: 'center', // currently, center or not-center are the only options
  position: 'bottom', // currently, bottom or right are the only options
  positionFixed: 1,
  /* do we allow the position to flip (from bottom to top, or right to left)
  if there isn't enough room on the screen? */
  positionAllowOutsideViewport: 0, // 0: always position within viewport, 1:
  tipTargetSelector: null, // where the tooltip should point. If null, points to target
  animate: 1, // 1: animation the appearance of the popup, 0: do not animiate
  message: null, // The content which will appear inside the popup
  width: null, // The width of the popup: pixels | "auto" | "target" | "window"
  closeBox: false, // Show the "X" link to close the popup
  bindTargetHover: 0, // Automatically bind mouseover/mouseout events to target
  scope: null, // Optional: Scope/content of where the popup appears.  Useful when appearing in Ajax content
  size: 'medium', // Size: Small, medium, large, full
  hideOnBodyClick: false,
  zIndex: null, // optional: overriding automatic z-index calculation
  customPulldownTargetElement: EMPTY_STRING, // This is only used for custom pulldown code.
};
